import { ehEventoObito } from "./formatarTimeline";

const converterDataParaTimestamp = (valorData) => {
	if (!valorData || typeof valorData !== "string") {
		return Number.NEGATIVE_INFINITY;
	}

	if (/^\d{4}-\d{2}-\d{2}$/.test(valorData)) {
		const dataSomenteDia = new Date(`${valorData}T00:00:00Z`);
		return Number.isNaN(dataSomenteDia.getTime())
			? Number.NEGATIVE_INFINITY
			: dataSomenteDia.getTime();
	}

	const valorNormalizado = valorData
		.replace(/(\.\d{3})\d+/, "$1")
		.replace(
			/^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{1,3})?)(?!Z|[+-]\d{2}:?\d{2})$/,
			"$1Z",
		);

	const dataCompleta = new Date(valorNormalizado);

	return Number.isNaN(dataCompleta.getTime())
		? Number.NEGATIVE_INFINITY
		: dataCompleta.getTime();
};

export const ordenarPorLiberacaoEProcessamento = (a, b) => {
	const bEhObito = ehEventoObito(b);
	const aEhObito = ehEventoObito(a);

	if (bEhObito !== aEhObito) {
		return Number(bEhObito) - Number(aEhObito);
	}

	const liberacaoB = converterDataParaTimestamp(b.dataLiberacao);
	const liberacaoA = converterDataParaTimestamp(a.dataLiberacao);

	if (liberacaoB !== liberacaoA) {
		return liberacaoB - liberacaoA;
	}

	const processamentoB = converterDataParaTimestamp(b.dataProcessamento);
	const processamentoA = converterDataParaTimestamp(a.dataProcessamento);
	return processamentoB - processamentoA;
};

export default ordenarPorLiberacaoEProcessamento;
